export const gitVersion = {
  'commit': '6b5f4d5',
  'branch': 'Detached: 6b5f4d536ac4ebc8e0653f66c7ceceeee721d229'
};
